module.exports = __webpack_public_path__ + "img/white.b2833d09.jpeg";